import { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { formValidation } from './../MessageCreate/formValidation'
import { Typography, TextField } from '@material-ui/core'
import { func, object, string } from 'prop-types'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '100%',
  },
}))

const objectToMultiline = (input, value, listDataType) => {
  var returnVar = ''
  if (
    input !== null &&
    input !== '' &&
    (typeof input !== 'object' || Object.keys(input).length > 0)
  ) {
    Object.keys(input).map(function (key) {
      if (input[key]) {
        if (value === 'precall' && listDataType === 'store') {
          returnVar = 'T' + key + '\n' + returnVar
        } else if (listDataType === 'teammember') {
          returnVar = key + '\n' + returnVar
        }
      }
      return returnVar.trim()
    })
  }
  return returnVar.trim()
}

// return true if there's an error, otherwise return false
const multiLineformValidation = (input, listDataType) => {
  if (
    input !== null &&
    input !== '' &&
    (typeof input !== 'object' || Object.keys(input).length > 0)
  ) {
    var lines = input.split('\n')
    if (listDataType === 'store') {
      for (var i = 0; i < lines.length; i++) {
        if (formValidation(lines[i], 'store', 'boolean')) {
          return true
        }
      }
    } else if (listDataType === 'teammember') {
      for (var g = 0; g < lines.length; g++) {
        if (formValidation(lines[g], 'teammember', 'boolean')) {
          return true
        }
      }
    }
  }
  return false
}

const multiLineToObject = (input, value, listDataType) => {
  if (
    input !== null &&
    input !== '' &&
    (typeof input !== 'object' || Object.keys(input).length > 0)
  ) {
    var lines = input.split('\n')
    var myObject = {}
    for (var i = 0; i < lines.length; i++) {
      var myLine = lines[i]
      if (value === 'precall' && listDataType === 'store') {
        // Remove leading T
        myLine = myLine.replace('T', '')
        myLine = myLine.replace('t', '')
      }
      myObject[myLine] = true
    }
    return myObject
  }
  return input
}

const WorkerTextBox = (props) => {
  const classes = useStyles(props)
  const {
    workerListFromParent,
    blossomIDFromParent,
    listDataTypeFromParent,
    callbackFromParent,
    callbackFromParentTotals,
  } = props
  const [textBoxData, settextBoxData] = useState(
    objectToMultiline(
      workerListFromParent,
      blossomIDFromParent,
      listDataTypeFromParent,
    ),
  )
  const [multilineError, setmultilineError] = useState(
    multiLineformValidation(
      objectToMultiline(
        workerListFromParent,
        blossomIDFromParent,
        listDataTypeFromParent,
      ),
    ),
  )
  const [blossomID, setblossomID] = useState(blossomIDFromParent)
  const [listDataType, setlistDataType] = useState(listDataTypeFromParent)

  const checkWorkerSelected = (newSelected) => {
    callbackFromParent(newSelected)
    callbackFromParentTotals(Object.keys(newSelected).length)
  }

  useEffect(() => {
    if (blossomIDFromParent !== blossomID) {
      setblossomID(blossomIDFromParent)
    }
    if (listDataTypeFromParent !== listDataType) {
      setlistDataType(listDataTypeFromParent)
    }
  }, [blossomIDFromParent, listDataTypeFromParent, blossomID, listDataType])

  const handleChange = (name) => (event) => {
    // Validate the multiline data
    if (name === 'textBoxData') {
      var returnVar = {}
      settextBoxData(event.target.value)
      if (
        multiLineformValidation(event.target.value, listDataTypeFromParent) ===
        false
      ) {
        setmultilineError(false)
        returnVar = multiLineToObject(
          event.target.value,
          blossomIDFromParent,
          listDataTypeFromParent,
        )
      } else if (name === 'textBoxData') {
        setmultilineError(true)
      }
      // send the data back up to the parent class
      checkWorkerSelected(returnVar)
    }
  }

  let workerTextField = ''

  if (listDataType === 'store') {
    workerTextField = (
      <TextField
        id="standard-multiline-flexible"
        label="T0000"
        multiline
        maxRows="20"
        value={textBoxData}
        helperText="Insert Store numbers in the T0000 format.  Separate stores by newlines."
        onChange={handleChange('textBoxData')}
        className={classes.textField}
        margin="normal"
        error={multilineError}
      />
    )
  }
  if (listDataType === 'teammember') {
    workerTextField = (
      <TextField
        id="standard-multiline-flexible"
        label="0012345678"
        multiline
        maxRows="20"
        value={textBoxData}
        helperText="Insert Team Member numbers (10 characters). Add each TM number on a new line or copy and paste full column detail from an excel document."
        onChange={handleChange('textBoxData')}
        className={classes.textField}
        margin="normal"
        error={multilineError}
      />
    )
  }

  return (
    <form className={classes.container} noValidate autoComplete="off">
      {workerTextField}
      <Typography component="span" variant="body2" align="center">
        Please note that TOM may block messages sent to team members(s) that are
        not in compliance with local laws.
      </Typography>
    </form>
  )
}

export default WorkerTextBox

WorkerTextBox.propTypes = {
  workerListFromParent: object.isRequired,
  blossomIDFromParent: string.isRequired,
  listDataTypeFromParent: string.isRequired,
  callbackFromParent: func.isRequired,
  callbackFromParentTotals: func.isRequired,
}
